import { Box, VStack, Text, Button, Image } from '@chakra-ui/react';
import NotFoundImage from 'assets/common/error404.png';
import NotFoundImageFlashcards from 'assets/common/fc-not-found.png';
import { ReactElement, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IndexRoutes, PublicRoutes } from 'types/Routes';
import { useBreakpoint } from 'hooks/utils/layout/useBreakpoint';
import { Breakpoints } from 'types/breakpoints';
import { useCurrentRoute } from 'hooks/utils/useCurrentRoute';

type NotFoundProps = {
  title?: string;
  buttonText?: string;
  buttonLink?: string;
};

export const NotFound = ({
  title = 'Diese Seite wurde nicht gefunden.',
  buttonText = 'Zum Login',
  buttonLink = PublicRoutes.LOGIN,
}: NotFoundProps): ReactElement => {
  const navigate = useNavigate();
  const isDesktop = useBreakpoint(Breakpoints.DESKTOP);
  const buttonWidth = isDesktop ? '40%' : 'full';
  const location = useLocation();
  const { currentRoute } = useCurrentRoute(location);

  // Define routes that are only available within the app
  const nativeOnlyRoutes: string[] = ['/app/flashcards', '/app/track'];

  const nativeOnlyMessage =
    'Diese Funktion ist exklusiv in unserer App verfügbar! 🚀 Lade sie jetzt herunter und entdecke alle spannenden Features.';
  const defaultMessage =
    'Ups! Diese Seite existiert nicht. Keine Sorge - über den Button gelangst du sicher zurück zur App und kannst direkt loslegen!';

  // Check if current route is app-only
  const isAppOnlyRoute = nativeOnlyRoutes.some((route) => location.pathname.includes(route));

  const notFoundHeading = isAppOnlyRoute
    ? 'Diese Funktion ist nur in der App verfügbar! 📱'
    : title;
  const notFoundMessage = isAppOnlyRoute ? nativeOnlyMessage : defaultMessage;

  useEffect(() => {
    if (currentRoute === IndexRoutes.FIRST_TIME) navigate(PublicRoutes.BASE);
  }, [currentRoute, navigate]);
  return (
    <VStack
      mt="20"
      display="flex"
      alignItems="center"
      px="8"
      textAlign="center"
      gap="50"
      mx="auto"
      pb="40px"
    >
      <Image src={isAppOnlyRoute ? NotFoundImageFlashcards : NotFoundImage} maxHeight="50vh" />
      <Box>
        <Text as="h2" textStyle="h1.medium" color="text.primary">
          {notFoundHeading}
        </Text>
        <Text as="h3" textStyle="h4.regular" color="text.primary" mt="4">
          {notFoundMessage}
        </Text>
      </Box>
      <Button variant="primary" w={buttonWidth} onClick={() => navigate(buttonLink)}>
        {buttonText}
      </Button>
    </VStack>
  );
};
